<template>
	<b-modal
		ref="brain-specimen-dead-details-modal"
		size="lg"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bolder">Detalle de Motivo: {{ reason.name }}</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-row class="mb-1">
				<b-col class="d-flex align-items-center">
					<small class="text-secondary">
						Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
					</small>
				</b-col>
				<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
					<b-pagination
						v-model="pagination.curPage"
						:total-rows="pagination.total"
						:per-page="pagination.perPage"
						first-number
						last-number
						class="mb-0 mt-1 mt-sm-0"
						prev-class="prev-item"
						next-class="next-item"
					>
						<template #prev-text>
							<feather-icon icon="ChevronLeftIcon" size="18" />
						</template>
						<template #next-text>
							<feather-icon icon="ChevronRightIcon" size="18" />
						</template>
					</b-pagination>
				</b-col>
			</b-row>
			<b-row class="mb-1">
				<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mt-1 mb-md-0">
					<label>Mostrar</label>
					<v-select
						v-model="pagination.perPage"
						:options="perPageOptions"
						:clearable="false"
						class="per-page-selector d-inline-block mx-50"
						style="width: 90px"
					/>
					<label class="mr-2">registros</label>
					<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
				</b-col>
				<b-col cols="12" xl="5">
					<div class="container-btns-page-specimens">
						<div class="d-flex">
							<b-input-group id="cintillo-ala-input-group">
								<b-form-input
									v-model="search"
									class="d-inline-block"
									placeholder="Buscar por placa o alias"
									@keyup.enter="handleInputSearch"
									debounce="500"
								/>
								<b-input-group-append>
									<b-button variant="outline-primary" @click="handleInputSearch()">
										<feather-icon class="cursor-pointer" icon="SearchIcon" />
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="rows.length > 0">
						<b-tr v-for="(row, index) in rows" :key="index">
							<b-td class="text-center">
								<SpecimenPlate :specimen="row.specimen" show_details_icon />
							</b-td>
							<b-td class="text-center text-danger font-weight-bolder">
								{{ row.is_depuration_reason ? "DEPURADO" : "MUERTO" }}
							</b-td>
							<b-td class="text-center">
								{{ row.date_dead | myGlobalDayShort }}
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="rows.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SpecimenStatusService from "@/services/specimenStatus.service.js"
export default {
	name: "BrainSpecimenDeadDetails",
	props: {
		reason: {
			required: true,
		},
	},
	components: {
		SpecimenPlate,
	},
	data: () => ({
		isLoading: false,
		fields: [
			{ key: "specimen", label: "Ejemplar", class: "text-center" },
			{ key: "type", label: "TIPO", class: "text-center" },
			{ key: "date", label: "FECHA", class: "text-center" },
		],
		rows: [],
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
		search: "",
	}),
	computed: {},
	methods: {
		handleCloseModal() {
			this.$emit("close")
		},
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		async getRows(page = 1) {
			try {
				this.isLoading = true
				const { data } = await SpecimenStatusService.getDeadSpecimens({
					reason_id: this.reason.id,
					page: page,
					per_page: this.pagination.perPage,
					search: this.search,
				})
				this.rows = data.data
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
			} catch (error) {
				console.error("Error fetching dead specimen details:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	watch: {
		"pagination.curPage": async function () {
			await this.getRows(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getRows()
		},
	},
	mounted() {
		this.$refs["brain-specimen-dead-details-modal"].toggle()
		this.getRows()
	},
}
</script>

<style scoped>
.glove-blue {
	color: #007bff !important;
}
</style>
